import React, { useState } from 'react';
import { Bot } from 'lucide-react';
import { DANA } from '@/lib/dana';

/**
 * Dana's circular avatar. The source portrait is a full-body brand render, so we
 * frame it to her face with a CSS zoom (background-size + position) — this scales
 * cleanly to any size and crops out the caption/legs. Falls back to the Bot glyph
 * on an orange tile if the image ever fails to load.
 */
export const DanaAvatar: React.FC<{ size?: number; className?: string; ring?: boolean }> = ({
  size = 40,
  className = '',
  ring = false,
}) => {
  const [failed, setFailed] = useState(false);
  const ringCls = ring ? 'ring-2 ring-white/60' : '';

  if (failed) {
    return (
      <div
        className={`rounded-full bg-gradient-to-br from-orange-500 to-amber-500 text-white flex items-center justify-center shrink-0 ${ringCls} ${className}`}
        style={{ width: size, height: size }}
        role="img"
        aria-label="Dana, AI HR Assistant"
      >
        <Bot style={{ width: size * 0.55, height: size * 0.55 }} />
      </div>
    );
  }

  return (
    <div
      className={`rounded-full shrink-0 bg-orange-400 ${ringCls} ${className}`}
      style={{
        width: size,
        height: size,
        backgroundImage: `url(${DANA.avatar})`,
        backgroundSize: '220%',
        backgroundPosition: '50% 11%',
        backgroundRepeat: 'no-repeat',
      }}
      role="img"
      aria-label="Dana, AI HR Assistant"
    >
      {/* Hidden probe so we can fall back if the asset 404s. */}
      <img src={DANA.avatar} alt="" className="hidden" onError={() => setFailed(true)} />
    </div>
  );
};

export default DanaAvatar;
